import React from 'react';
import PropTypes from 'prop-types';
import SignUp from './SignUp';
import Profile from './Profile';
import Modal from './Modal';
import './LoginModal.css';

export default function SignUpModal(props) {
  const isCloseable = true;
  const onRequestClose = isCloseable ? props.onRequestClose : () => {};

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={onRequestClose}
      className={`${props.page}-modal`}
      showCloseButton={isCloseable}
    >
      {props.page === 'login' ? <SignUp {...props} /> : <Profile {...props} />}
    </Modal>
  );
}

SignUpModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  ...SignUp.PropTypes
};


// WEBPACK FOOTER //
// ./src/components/SignUpModal.js